import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";

const track = (name, props = {}) => {
  if (typeof window !== "undefined" && window.clarity) {
    window.clarity("event", name, props);
  }
};

const SpecialOfferModal = () => {
  const navigate = useNavigate();
  const [offer, setOffer] = useState(null);

  const isDismissed = (id) =>
    sessionStorage.getItem(`dismiss_offer_${id}`) === "true";

  const dismiss = () => {
    if (offer?.dismissible) {
      sessionStorage.setItem(`dismiss_offer_${offer.id}`, "true");
    }
    track("offer_popup_dismiss", { offerId: offer?.id || "" });
    setOffer(null);
  };

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/offers.json`)
      .then((res) => res.json())
      .then((data) => {
        const popupOffer = (data || []).find(
          (o) => o.visible && o.type === "popup" && !isDismissed(o.id)
        );

        if (popupOffer) {
          setOffer(popupOffer);
          track("offer_popup_show", { offerId: popupOffer.id });
        }
      })
      .catch((err) => console.error("Failed to load offer:", err));
  }, []);

  if (!offer) return null;

  const goLogin = () => {
    track("offer_popup_login_click", { offerId: offer.id });
    const url = config.signInUrl;
    if (url && url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      navigate("/login");
    }
  };

  // UPDATED: Function now redirects to /pricing
  const goPricing = () => {
    track("offer_popup_pricing_click", { offerId: offer.id });
    navigate("/pricing"); 
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4 md:px-0">
      <div
        className={`relative w-full max-w-md bg-white rounded-lg p-6 shadow-lg mx-auto ${
          offer.bgColor || ""
        } ${offer.textColor || ""}`}
      >
        <button
          onClick={dismiss}
          className="absolute top-2 right-3 text-xl font-bold text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>

        <h2 className="text-lg font-semibold mb-4 text-center">🎁 Special Offer</h2>
        <p className="text-sm text-center mb-6">{offer.message}</p>

        <div className="flex justify-center gap-4">
          {/* UPDATED: Button text and function call */}
          <button
            onClick={goPricing}
            className="bg-orange-100 text-gray-800 font-bold px-5 py-2 rounded-full hover:bg-orange-200 transition"
          >
            Explore Now
          </button>
          
          <button
            onClick={goLogin}
            className="bg-orange-100 text-gray-800 font-bold px-5 py-2 rounded-full hover:bg-orange-200 transition"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferModal;